import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir().toLowerCase() === 'rtl';

  return (
    <footer className='site-footer'>
      <Container className='text-center' dir={isRTL ? 'rtl' : 'ltr'}>
        <div className='brand'>Licorne Professional Academy</div>
        <div className='footer-links'>
          <Link to='/'>{t('inperson')}</Link>
          <Link to='/online'>{t('online')}</Link>
          <Link to='/other'>{t('otherProduct')}</Link>
        </div>
        <div className='copy'>
          {t('lc')} &copy; {currentYear} {t('copyright')}
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
